module.exports = __webpack_public_path__ + "img/CS-ECONew-User.a07a69cc.jpg";